import { AppState } from 'store/store';
import { offlineReportsSlice } from 'store/offline-reports/offline-reports-slice';

export const offlineReportsReducer = {
    offlineReports: offlineReportsSlice.reducer,
};

export type OfflineReportsState = AppState;

